<template>
  <!--  资源中心-->
  <div
      style="
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
	  padding-top: 30px;
    "
  >
    <Breadcrumb
        :value="[$t('h.tabName1'), $t('h.tabName4'), $t('h.tabResourceCenter')]"
    />
    <div
        style="width: 1200px;height: auto;padding-bottom: 100px;display: flex;flex-direction: column;align-items: center;">
      <div class="baseTitle" style="padding-top: 60px; padding-bottom: 60px">
        {{ $t("h.tabName4Item2") }}
      </div>
      <div
          @click="openFileBtn(item)"
          v-for="(item, index) in listData"
          :key="index"
          :style="index === listData.length - 1 ? 'border-bottom: 1px solid #D8D8D8;' : ''"
          style="
          width: 1120px;
          height: 76px;
          border-top: 1px solid #d8d8d8;
          border-left: 1px solid #d8d8d8;
          border-right: 1px solid #d8d8d8;
          border-radius: 1px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 30px;
        ">
        <div
            class="customLabel"
            style="
            font-family: SourceHanSansCN-Medium;
            font-size: 16px;
            color: #444444;
            cursor: pointer;
          "
          >
          {{ language === "ZH" ? item.title : item.titleEn || item.title }}
        </div>
        <div
            style="
            width: 42px;
            height: 42px;
            overflow: hidden;
            border-radius: 4px;
          ">
          <img class="customImage" src="@/assets/img/sousuo.png" />
        </div>
      </div>

      <div class="baseTitle" style="padding: 60px 0">
        {{ $t("h.tabName3Item2") }}
      </div>

      <div
          @click="openFileBtn(item)"
          v-for="(item, index) in listData2"
          :key="index" :style="index === listData2.length - 1 ? 'border-bottom: 1px solid #D8D8D8;' : ''"
          style="
          width: 1120px;
          height: 76px;
          border-top: 1px solid #d8d8d8;
          border-left: 1px solid #d8d8d8;
          border-right: 1px solid #d8d8d8;
          border-radius: 1px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 30px;
        ">
        <div
            class="customLabel"
            style="
            font-family: SourceHanSansCN-Medium;
            font-size: 16px;
            color: #444444;
            cursor: pointer;
          ">
          {{ language === "ZH" ? item.title : item.content || item.title }}
        </div>
        <div
            style="
            width: 42px;
            height: 42px;
            overflow: hidden;
            border-radius: 4px;
          ">
          <img class="customImage" src="@/assets/img/sousuo.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleList,compnayJoinList } from "@/assets/api";
export default {
  name: "ResourceCenter",
  mounted() {
    this.$axios.get(articleList).then((res) => {
      this.listData = res.data.result.filter(item => {
        // Filter based on language: if Chinese, only show items without titleEn, if English, only show items with titleEn
        if (this.language === 'ZH') {
          return !item.titleEn;
        } else {
          return item.titleEn;
        }
      });
    });
    this.$axios.get(compnayJoinList).then((res) => {
      this.listData2 = res.data.result;
    });
  },
  data() {
    return {
      language: localStorage.getItem("lang") || "ZH",
      listData: [],
      listData2: []
    };
  },
  methods: {
    openFileBtn(item) {
      window.open(item.urlAddress || item.fileUrl, "_blank");
    },
  },
};
</script>

<style scoped></style>
